import * as React from "react";
import { IFormInputValuePresentationModel } from "../../../../presenter/form/model/FormInputValuePresentationModel";
import { IFormQualifierAttributePresentationModel } from "../../../../presenter/form/model/FormQualifierAttributePresentationModel";
import { IReferenceValue } from "../../../../model/form/ReferenceValue";
import { IFormInputValueValidationError } from "../../../../model/validation/FormInputValueValidationError";
import { DateService } from "../../../../service/DateService";
import { View, Text, Font } from "@react-pdf/renderer";
import { AttributeFormConstants } from "../../../../common/Constants";
import NumberFormatter from "../../../../model/common/NumberFormatter";
import { Date2Utils } from "../../../../common/utils/Date2Utils";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

export interface State {
  value: any;
  placeholder?: string;
  formInputValue?: IFormInputValuePresentationModel;
  isEditableForm: boolean;
}

export interface Props {
  translate: any;
  attribute: IFormQualifierAttributePresentationModel;
  getReferenceValues: any;
  referenceValueList?: IReferenceValue[];
  isEditableForm: boolean;
  rowIndex: number;
  changeFormAttribute: any;
  validationErrors?: IFormInputValueValidationError[];
  formTypeCode: string;
  qualifierCode: string;
  width: number;
  styles: any;
  isParentQualifierMultiAttribute: boolean;
}

export default class DisplayFormQualifierAttributePDF extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    const { attribute, rowIndex, isEditableForm } = props;

    const formInputValue = attribute?.values
      ? attribute.values[rowIndex]
      : undefined;

    this.state = {
      formInputValue,
      value: formInputValue?.value,
      isEditableForm
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { attribute, rowIndex, isEditableForm } = this.props;

    let formInputValue = attribute?.values
      ? attribute.values[rowIndex]
      : undefined;

    let prevStateFormInputValue = prevState?.formInputValue;

    if (
      formInputValue &&
      prevStateFormInputValue &&
      (formInputValue.value !== prevStateFormInputValue.value ||
        formInputValue?.isRequiredFlagVisible !==
          prevStateFormInputValue.isRequiredFlagVisible ||
        formInputValue?.formAttributeId !==
          prevStateFormInputValue.formAttributeId ||
        isEditableForm !== prevState.isEditableForm)
    ) {
      this.setState({
        value: formInputValue.value,
        formInputValue: formInputValue,
        isEditableForm
      });
    }
  }

  parseDate = (date: Date) => {
    return DateService().formatDate(date);
  };

  getValue = () => {
    return this.state.value;
  };

  setValue = (value: any) => {
    this.setState({ value });
  };

  getDate2Value = (value?: string) => {
    const { translate } = this.props;

    if (value && value.length !== 0) {
      const { month, year } = Date2Utils().parseDate2(value);
      if (month) {
        return `${translate(`months.${month}`)} ${year}`;
      }
      return year;
    }
    return "";
  };

  renderValue() {
    const { value, formInputValue } = this.state;
    const { attribute } = this.props;

    let formattedValue: string | undefined = undefined;

    const isValueMasked: boolean =
      formInputValue?.visible !== undefined && !formInputValue?.visible;

    if (value && !isValueMasked) {
      if (
        attribute.attributeType === AttributeFormConstants.TYPE_VALUES.DATE ||
        attribute.attributeType ===
          AttributeFormConstants.TYPE_VALUES.INITIAL_DATE
      ) {
        formattedValue = this.parseDate(value);
      } else if (
        attribute.attributeType === AttributeFormConstants.TYPE_VALUES.NUMBER ||
        attribute.attributeType ===
          AttributeFormConstants.TYPE_VALUES.INITIAL_NUMBER
      ) {
        formattedValue = NumberFormatter().formatReadOnlyValue(value);
      } else if (
        attribute.attributeType === AttributeFormConstants.TYPE_VALUES.DATE_2
      ) {
        formattedValue = this.getDate2Value(value);
      }
    }
    return formattedValue || value || "";
  }

  renderLabel = () => {
    const { attribute, isParentQualifierMultiAttribute } = this.props;

    const label = attribute.labelVisible
      ? attribute.name || attribute.attributeName
      : undefined;

    if (label && isParentQualifierMultiAttribute) {
      return `${label}: `;
    }
    return "";
  };

  renderField = () => {
    const { formInputValue } = this.state;
    const { styles } = this.props;

    return (
      <View
        style={this.props.styles.attribute}
        key={formInputValue && formInputValue.formAttributeId.toString()}
      >
        <Text
          style={styles.value}
        >{`${this.renderLabel()}${this.renderValue()}`}</Text>
      </View>
    );
  };

  render() {
    return (
      <View style={{ paddingTop: 3, paddingBottom: 3 }}>
        {this.renderField()}
      </View>
    );
  }
}


Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    { src: SagoeUi }
  ]
});
